import router from "router";

class NavigationService {
  navigate(path, options) {
    router.navigate(path, options);
  }
}

export default new NavigationService();
